import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
import './scss/app.scss'
import './assets/styles/responsive.scss'

const app = createApp(App)

// ใช้ Ant Design
app.use(Antd)

// ใช้ Router
app.use(router)

// Register Global Layout Components
app.component('layout-default', DefaultLayout)
app.component('layout-dashboard', DashboardLayout)
app.component('layout-dashboard-rtl', DashboardRTLLayout)

// Mount App
app.mount('#app')